import { Controller } from '@hotwired/stimulus';

const DESKTOP = '(min-width: 768px)';
const NUDGES = { ArrowLeft: -1, ArrowRight: 1 };
const DIRECTIONS = { left: 1, right: -1 };

export default class extends Controller {
  static targets = ['panel'];

  static values = { anchor: String, max: Number, min: Number, step: Number, storageKey: String };

  connect() {
    this.onMove = (event) => this.#widen(this.startWidth + this.#direction * (event.clientX - this.startX));
    this.onRelease = () => this.#release();

    this.#restore();
  }

  disconnect() {
    this.#release();
  }

  start(event) {
    event.preventDefault();

    this.startX = event.clientX;
    this.startWidth = this.panelTarget.offsetWidth;

    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
    window.addEventListener('mousemove', this.onMove);
    window.addEventListener('mouseup', this.onRelease);
  }

  nudge(event) {
    const towards = NUDGES[event.key];

    if (towards === undefined) return;

    event.preventDefault();

    this.#widen(this.panelTarget.offsetWidth + this.#direction * towards * this.stepValue);
  }

  get #direction() {
    return DIRECTIONS[this.anchorValue];
  }

  #release() {
    document.body.style.userSelect = '';
    document.body.style.cursor = '';
    window.removeEventListener('mousemove', this.onMove);
    window.removeEventListener('mouseup', this.onRelease);
  }

  #widen(width) {
    const bounded = Math.min(this.maxValue, Math.max(this.minValue, width));

    this.panelTarget.style.width = `${bounded}px`;
    localStorage.setItem(this.storageKeyValue, String(bounded));
  }

  #restore() {
    const stored = Number(localStorage.getItem(this.storageKeyValue));

    if (!window.matchMedia(DESKTOP).matches) return;
    if (stored < this.minValue || stored > this.maxValue) return;

    this.panelTarget.style.width = `${stored}px`;
  }
}
